export default "__VITE_ASSET__l0rGeOBo__"